import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { CustomDropdown } from 'src/components/RealityCheckForm/CustomDropdown';
import { ReactivateSelfExclusionState } from './ReactivateSelfExclusion.state';

interface SelfExclusionPeriodFormPropsType {
    state: ReactivateSelfExclusionState;
}

export const SelfExclusionPeriodForm = observer(
    'SelfExclusionPeriodForm',
    ({ state }: SelfExclusionPeriodFormPropsType) => {
        return (
            <>
                <p>Please select the self exclusion period</p>
                <CustomDropdown
                    optionsList={state.selfExclusionOptionsArray}
                    selectedValue={(): string | null => state.selectedValue}
                    onChangeCallback={state.onSelectPeriod}
                    placeholder='Select exclusion period'
                    dataTest='self-exclusion-period-dropdown'
                    labelHeader='Exclusion period'
                />
            </>
        );
    }
);
